import { render, staticRenderFns } from "./rlbadd.vue?vue&type=template&id=7ddaf2ed&scoped=true&"
import script from "./rlbadd.vue?vue&type=script&lang=js&"
export * from "./rlbadd.vue?vue&type=script&lang=js&"
import style0 from "./rlbadd.vue?vue&type=style&index=0&id=7ddaf2ed&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddaf2ed",
  null
  
)

export default component.exports